import React from 'react'
import Link from 'gatsby-link'
import forEach from 'lodash/forEach'
import get from 'lodash/get'
import './style.scss'
import { connect } from 'react-redux'
import moment from 'moment'

class SiteEvent extends React.Component {
  more(path) {
    return (
      <Link className="readmore" to={path}>
        <span className="btn btn-outline-primary btn-block">MORE</span>
      </Link>
    )
  }

  isMore(body) {
    return body.match('<!--more-->')
  }

  description(body) {
    let test = body.replace(/<blockquote>/g, '<blockquote class="blockquote">')
    if (test.match('<!--more-->')) {
      test = test.split('<!--more-->')
      if (typeof test[0] !== 'undefined') {
        return test[0]
      }
    }
    return test
  }

  categories(data) {
    const categories = []
    forEach(data, (item, i) => {
      categories.push(
        <span className="badge badge-primary text-white" key={i}>
          {item}
        </span>
      )
    })
    return categories
  }

  render() {
    const { site, data, isIndex, now, browser } = this.props
    const title = get(data, 'frontmatter.title')
    const path = get(data, 'frontmatter.path')
    const date = get(data, 'frontmatter.date')
    const when = moment(get(data, 'frontmatter.when'))
    const where = get(data, 'frontmatter.where')
    const html = get(data, 'html')
    const description =
      get(data, 'frontmatter.description') || this.description(html)
    const cate =
      get(data, 'frontmatter.category') || get(data, 'frontmatter.categories')
    const isMore = isIndex && !!html.match('<!--more-->')

    const classNames = ['list-group-item']

    if (browser) {
      console.log('now', now)
      console.log('when', when)
      if (now.format('YYYY-MM-DD') === when.format('YYYY-MM-DD')) {
        classNames.push('list-group-item-primary')
      } else if (now.isAfter(when)) {
        classNames.push('disabled')
      }
    }

    if (isIndex) {
      return (
        <li className={classNames.join(' ')}>
          {title} (när: {when.format('YYYY-MM-DD HH:mm')}, var: {where})
        </li>
      )
    }

    return (
      <div className="container">
        <div className="articles col-md-12">
          <div className="article-wrap" key={path}>
            <div className="page-header">
              <Link style={{ boxShadow: 'none' }} to={path}>
                <h1>{title}</h1>
                <time dateTime={date}>{date}</time>
              </Link>
              {this.categories(cate)}
            </div>
            <div
              className="page-content"
              dangerouslySetInnerHTML={{ __html: isMore ? description : html }}
            />
            {isMore ? this.more(path) : ''}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ now, browser }) => {
  return { now, browser }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteEvent)



// WEBPACK FOOTER //
// ./src/components/SiteEvent/index.jsx